import React from "react"

import {
  PageHeroContainer,
  PageHeroDescription,
  PageHeroTitle,
  ImageStatsContainer,
  ImageStatsInnerContainer,
  StatsImage,
} from "./courses-page-hero.styles.js"

import StatCard from "../stat-card/stat-card.component"


const CoursesPageHero = ({ stats, courseHeaderImages, lessonsImage, videosImage, coursesImage, title, desc, typography, typoSize, ...otherProps }) => {

  const imageStatPairs = [
    { image: lessonsImage.gatsbyImageData, title: lessonsImage.title, stat: stats[0] },
    { image: videosImage.gatsbyImageData, title: videosImage.title, stat: stats[1] },
    { image: coursesImage.gatsbyImageData, title: coursesImage.title, stat: stats[2] },
  ];

  return (
    <>
      <PageHeroContainer {...otherProps}>
        <PageHeroTitle>{title}</PageHeroTitle>
        <PageHeroDescription mt={[20, 20, 25, 25]} mb={[20, 20, 25, 25]}>
          {desc}

        </PageHeroDescription>
        <ImageStatsContainer>
          {imageStatPairs.map((item, i) => (
            <ImageStatsInnerContainer key={i}>
              <StatsImage image={item.image} alt={item.title} />
              <StatCard stat={item.stat} />
            </ImageStatsInnerContainer>
          ))}
        </ImageStatsContainer>
      </PageHeroContainer>

    </>
  )
}

export default CoursesPageHero
